import React from 'react';
import {Box, useTheme} from '@mui/material';
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';

const CustomDatePicker = (props) => {
    const {value, onChange, placeholder = "Select date", fullWidth = true, size = "small", sx, disabled, minDate, maxDate} = props;

    const theme = useTheme();

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box>
                <DatePicker
                    value={value}
                    onChange={onChange}
                    format="MMM DD, YYYY"
                    disabled={disabled ? disabled : false}
                    disablePast
                    minDate={minDate} 
                    maxDate={maxDate}
                    slotProps={{
                        textField: {
                            placeholder,
                            fullWidth,
                            size,
                            inputProps: {
                                readOnly: true,
                                inputMode: "none"
                            },
                            sx: {
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: "#e5edf6", 
                                    },
                                    '&:hover fieldset': {
                                        borderColor: "#e5edf6", 
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: "#253e5a9e",
                                    },
                                    
                                    '& input': {
                                        color: theme.typography.main,
                                        fontSize: 16,
                                        fontWeight: 500,

                                        '&::placeholder': {
                                            color: theme.typography.secondary,               
                                            opacity: 0.45,    
                                            fontSize: 15,    
                                            fontWeight: "400 !important",                     
                                        },
                                    },
                                }
                            }
                        },
                    }}
                />
            </Box>
        </LocalizationProvider>
    )
}

export default CustomDatePicker
